/**
 * Registers the Flex Living PWA service worker in production builds only.
 *
 * In development (webpack dev server / hot reload) a service worker would
 * aggressively cache stale assets and make changes invisible, so we skip
 * registration and actively unregister any leftover SW from a prior build.
 */
export function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return;

  const isProd = process.env.NODE_ENV === 'production';

  if (isProd) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/service-worker.js')
        .catch((err) => {
          // Intentional: never throw in console in production.
          console.warn('SW registration failed:', err); // eslint-disable-line no-console
        });
    });
  } else {
    // Clean up any SW from a previous production build so dev sees fresh code.
    navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((r) => r.unregister());
    }).catch(() => {});
  }
}
